<!-- 条形图 -->
<template>
  <div class="bar-chart">
    <div class="bar row-flex">
      <div class="left-bar" :style="{background:color[0],width:data[0]/(data[0] + data[1]) * 100 + '%'}" />
      <div class="right-bar" :style="{background:color[1],width:data[1]/(data[0] + data[1]) * 100 + '%'}" />
      <div class="bar-text clearfix">
        <span class="left">{{ ((data[0]/(data[0] + data[1]) * 100) || 0).toFixed(2) + '%' }}</span>
        <span class="right">{{ ((data[1]/(data[0] + data[1]) * 100) || 0).toFixed(2) + '%' }}</span>
      </div>
    </div>
    <div class="text clearfix">
      <div class="left-text left">
        <p>{{ leftText }}</p>
        <span :style="{color:color[0]}">{{ data[0] | unit('kWh') }}</span>
      </div>
      <div class="right-text right">
        <p>{{ rightText }}</p>
        <span :style="{color:color[1]}">{{ data[1]| unit('kWh') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    leftText: {
      type: String,
      default: ''
    },
    rightText: {
      type: String,
      default: ''
    },
    color: {
      type: Array,
      default () {
        return ['#fff', '#000']
      }
    },
    data: {
      type: Array,
      default () {
        return [0, 0]
      }
    }
  },
  data () {
    return {
    }
  }
}
</script>
<style lang='stylus' scoped>
.bar-chart
  width 100%
  margin-top 20px
.bar
  height 50px
  background-color #ccc
  border-radius 8px
  overflow hidden
  position relative
.left-bar
  height 50px
.right-bar
  height 50px
.bar-text
  position absolute
  width 100%
  height 50px
  padding 0 10px
  box-sizing border-box
  line-height 50px
  color #fff
.text
  padding 20px 30px 0
  font-size 16px
  p
    color #fff
  span
    line-height 30px
  .left-text
    position: relative
    &::before
      content ''
      position: absolute
      width 2px
      height 30px
      background-color #224A7F
      top -20px
      left -20px
    &::after
      content ''
      position: absolute
      width 15px
      height 2px
      background-color #224A7F
      top 10px
      left -20px
  .right-text
    position: relative
    &::before
      content ''
      position: absolute
      width 2px
      height 30px
      background-color #224A7F
      top -20px
      right -20px
    &::after
      content ''
      position: absolute
      width 15px
      height 2px
      background-color #224A7F
      top 10px
      right -20px
</style>
